import React, { createContext, useContext } from 'react';
import Utility from '../utils/utils';

const WebSocketContext = createContext();

export const WebSocketProvider = ({ children }) => {
  const websocketData = Utility();
  
  return (
    <WebSocketContext.Provider value={websocketData}>
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocket = () => {
  const context = useContext(WebSocketContext);
  if (!context) {
    throw new Error('useWebSocket must be used within WebSocketProvider');
  }
  return context;
};